import { useWorldT } from "../i18n.js";
import { setLookPrefs, useLookPrefs } from "./prefs.js";

/** Look sensitivity, inverted vertical look and the first-person head bob (this device). */
export function LookSettings() {
  const t = useWorldT();
  const p = useLookPrefs();
  return (
    <div className="world-controls-row world-look" data-testid="world-look">
      <label className="world-quality">
        <span>{t("nav.sensitivity")}</span>
        <input
          type="range"
          min={0.3}
          max={3}
          step={0.1}
          value={p.sensitivity}
          onChange={(e) => setLookPrefs({ sensitivity: Number(e.target.value) })}
          data-testid="world-sensitivity"
        />
      </label>
      <label className="world-quality">
        <input
          type="checkbox"
          checked={p.invertY}
          onChange={(e) => setLookPrefs({ invertY: e.target.checked })}
          data-testid="world-invert-y"
        />
        <span>{t("nav.invertY")}</span>
      </label>
      <label className="world-quality">
        <input
          type="checkbox"
          checked={p.headBob}
          onChange={(e) => setLookPrefs({ headBob: e.target.checked })}
          data-testid="world-head-bob"
        />
        <span>{t("nav.headBob")}</span>
      </label>
    </div>
  );
}
